import api from './api';

export const movieBookingApi = {
  getMovies: () => api.get('/api/movies'),
  getMovieById: (movieId) => api.get(`/api/movies/${movieId}`),
  getShowTimes: (movieId, city, date) =>
    api.get(`/api/movies/${movieId}/shows`, { params: { city, date } }),
  getSeatMap: (showId) => api.get(`/api/seats/shows/${showId}/seats`),
  lockSeats: (showId, payload) => api.post(`/api/seats/shows/${showId}/lock-seats`, payload),
  calculatePricing: (payload) => api.post('/api/pricing/calculate', payload),
  createBooking: (payload, idempotencyKey) =>
    api.post('/api/bookings', payload, { headers: { 'Idempotency-Key': idempotencyKey } }),
  authorizePayment: (payload) => api.post('/api/payments/authorize', payload),
  capturePayment: (payload) => api.post('/api/payments/capture', payload),
  getBooking: (bookingId) => api.get(`/api/bookings/${bookingId}`),
  getAdminTheatres: () => api.get('/api/admin/theatres'),
  getAdminShows: (theatreId) => api.get('/api/admin/shows', { params: { theatreId } }),
  createMovie: (payload) => api.post('/api/movies', payload),
  createTheatre: (payload) => api.post('/api/admin/theatres', payload),
  createShow: (payload) => api.post('/api/admin/shows', payload),
};
